import Axios from "axios";
import * as serviceURL from "./service-url";

export const RegistrationVerificationDetails = (id) => {
  return Axios.get(`${serviceURL.getVerificationList}` + id);
};
export const RejectionListDetails = (id) => {
  return Axios.get(`${serviceURL.rejectionList}` + id);
};
export const RegistrationVerificationEidUrl = (id) => {
  return Axios.get(`${serviceURL.getUploadUrl}` + id);
};
export const RejectEidUrl = (id) => {
  return Axios.get(`${serviceURL.getUploadRejectUrl}` + id);
};

export const getAllCommentListById = (id) => {
  return Axios.get(`${serviceURL.getAllCommentListById + id}`);
};
export const getCardStatus = (id) => {
  return Axios.get(`${serviceURL.getCardStatus + id}/card/status`);
};

export const addUserComment = ({ id, comment = "" }) => {
  return Axios.post(`${serviceURL.addUserComment + id}?comment=${comment}`, {
    id: id,
    comment: comment,
  });
};

export const approveVerification = (id) => {
  return Axios.post(`${serviceURL.approveRegistrations + id}`);
};

export const rejectVerification = (id, reasonId) => {
  return Axios.post(`${serviceURL.rejectRegistrations + id}/${reasonId}`, {});
};
export const getrejectReason = () => {
  return Axios.get(`${serviceURL.rejectReason}`);
};

export const getAtmPinNonRegister = (cardSerialNo) => {
  return Axios.get(`${serviceURL.getAtmPinNonRegisterUrl}/${cardSerialNo}`);
};
